<template>
	<div>
		<bread-crumbs
			:title="$t('Object.CreateObject')"
			:subTitle="$t('general.SubTitleObject')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<form-wizard
			v-if="objectsCreatePermission"
			color="rgba(var(--vs-primary), 1)"
			errorColor="rgba(var(--vs-danger), 1)"
			:title="null"
			:subtitle="null"
			:finishButton="false"
			:finishButtonText="$t('Resource.FinishButton')"
			:backButtonText="$t('Resource.BackButton')"
			:nextButtonText="nextButtonTextComputed"
			@on-change="handleChange"
		>
			<tab-content
				:title="$t('Resource.Definition')"
				class="mb-3"
				icon="feather icon-box"
				:before-change="validateStep1"
			>
				<!-- tab 1 content -->
				<form data-vv-scope="step-1">
					<vx-card style="box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1)">
						<bread-crumbs
							:title="$t('Resource.Definition')"
							:subTitle="$t('general.SubTitleObject')"
							:sizeTitle="22"
							:lineHeightTitle="27"
							:sizeSubTitle="13"
							:lineHeightSubTitle="16"
						></bread-crumbs>
						<vs-row vs-w="12">
							<div class="vx-col w-1/2">
								<label class="g-object--description" v-text="$t('Object.ObjectName')"></label>
								<vs-input
									v-model="typologyBody.name"
									class="w-full mt-2 mb-5"
									name="typologyBody.name"
									v-validate="{required: true, regex: this.regex}"
								/>
								<span
									class="text-danger text-sm"
									v-show="errors.has(typologyBody.name)"
									v-text="$t('Object.ValidMessages.name')"
								></span>
							</div>
						</vs-row>
						<vs-row vs-w="12">
							<div class="vx-col w-full">
								<label class="g-object--description" v-text="$t('Description')"></label>
								<vs-textarea v-model="typologyBody.description" class="w-full mt-2" rows="3" />
							</div>
						</vs-row>
					</vx-card>
				</form>
			</tab-content>

			<!-- tab 2 content -->
			<tab-content
				:title="$t('Resource.ObjectProperties')"
				class="mb-5"
				icon="feather icon-settings"
				:before-change="validateStep2"
			>
				<vx-card>
					<form data-vv-scope="step-2">
						<category-default
							v-if="newTipologyCreated && mountedCategory"
							ref="CategoryDefault"
							defaultAction="DEFINITION"
							:tipologies="listTipologies"
							:schema="{}"
							:additionalFields="false"
							:showEditIcon="false"
							:defaultTipology="nameP"
							@printHello="printHello"
							@selectedSchemaEmit="selectedSchemaEmit"
						></category-default>
						<div class="vx-row" v-else>
							<div class="vx-col md:w-1/1 w-full">
								<vx-card
									:title="$t('Resource.ObjectCreated')"
									title-color="primary"
									subtitle-color="warning"
								>
									<p class="mb-3">
										<code>{{ $t("Resource.Loading") }}</code>
									</p>
								</vx-card>
							</div>
						</div>
					</form>
				</vx-card>
			</tab-content>

			<!-- tab 3 content -->
			<tab-content
				:title="$t('Resource.Summary')"
				class="mb-5"
				icon="feather icon-layout"
				:before-change="validateStep3"
			>
				<form data-vv-scope="step-3">
					<resume-content>
						<template slot="content-text">
							<div v-if="categoryData">
								<p class="g-label--normal">
									{{ $t("Resource.NoticeNewObject.Text1") }}
									<code>{{ typologyBody.name }}</code>
									{{ $t("Resource.NoticeNewObject.Text2") }}
									<code>{{ categoryData.name }}</code>
									{{ $t("Resource.NoticeNewObject.Text3") }}
									<code>{{ $t("Next") }}</code>
									{{ $t("Resource.NoticeNewObject.Text4") }}
								</p>
							</div>
						</template>
						<template slot="content-left">
							<div v-if="categoryData">
								<vs-list>
									<vs-list-header
										color="#F9841E"
										:title="$t('Resource.PrincipalProperties')"
									></vs-list-header>
									<vs-list-item
										v-for="propertie in principalProperties"
										:key="propertie.name"
										:title="propertie.name"
										:subtitle="propertie.type"
									></vs-list-item>
								</vs-list>
							</div>
						</template>
						<template slot="content-right">
							<div v-if="categoryData">
								<vs-list>
									<vs-list-header
										:title="$t('Resource.AdditionalProperties')"
										color="success"
									></vs-list-header>
									<vs-list-item
										v-for="propertie in additionalProperties"
										:key="propertie.name"
										:title="propertie.name"
										:subtitle="propertie.type"
									></vs-list-item>
								</vs-list>
							</div>
						</template>
					</resume-content>
				</form>
			</tab-content>
			<!-- tab 4 content -->
			<tab-content
				:title="$t('Resource.FinishButton')"
				class="mb-5"
				icon="feather icon-send"
				:before-change="validateStep4"
			>
				<form data-vv-scope="step-4">
					<finalize-content>
						<p class="g-label--normal">{{ $t("Resource.FinalizeContent.Message") }}</p>
						<vs-button
							v-if="categoryData && categoryData.name === 'RESOURCE'"
							@click.prevent="$router.push('/apps/resource/resource-create')"
							color="primary"
							type="flat"
							>{{ $t("Resource.FinalizeContent.CreateResource") }}
						</vs-button>
						<vs-button
							v-if="categoryData && categoryData.name === 'VISIT_POINT'"
							@click.prevent="$router.push('/apps/visit-point/create')"
							color="primary"
							type="flat"
							>{{ $t("Resource.FinalizeContent.CreateVisitPoint") }}
						</vs-button>
						<vs-button color="success" type="flat" @click.prevent="$router.replace('/apps/category/list')"
							>{{ $t("Resource.FinalizeContent.ViewAllObject") }}
						</vs-button>
					</finalize-content>
				</form>
			</tab-content>
			<template slot="prev" v-if="disbableBottonPrev">{{ "" }}</template>
			<template slot="finish">{{ "" }}</template>
		</form-wizard>
		<not-permission v-else></not-permission>
	</div>
</template>

<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
// For custom error message
import {Validator} from "vee-validate";
import moduleCategory from "@/store/category/moduleCategory.js";
import moduleTipology from "@/store/tipology/moduleTipology.js";
import CategoryDefault from "@/components/category/CategoryDefault.vue";
import {dafultSchema} from "./data.js";
import FinalizeContent from "./FinalizeContent.vue";
import ResumeContent from "./ResumeContent.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

const dict = {
	custom: {
		first_name: {
			required: "First name is required",
			alpha: "First name may only contain alphabetic characters",
		},
		last_name: {
			required: "Last name is required",
			alpha: "Last name may only contain alphabetic characters",
		},
		email: {
			required: "Email is required",
			email: "Please enter valid email",
		},
		job_title: {
			required: "Job title name is required",
			alpha: "Job title may only contain alphabetic characters",
		},
		proposal_title: {
			required: "Proposal title name is required",
			alpha: "Proposal title may only contain alphabetic characters",
		},
		event_name: {
			required: "Event name is required",
			alpha: "Event name may only contain alphabetic characters",
		},
	},
};

// register custom messages
Validator.localize("en", dict);

export default {
	name: "DefinitionResource",
	data() {
		return {
			firstName: "",
			lastName: "",
			email: "",
			city: "new-york",
			proposalTitle: "",
			textarea: "",
			eventName: "",
			eventLocation: "san-francisco",
			status: "plannning",
			cityOptions: [
				{text: "New York", value: "new-york"},
				{text: "Chicago", value: "chicago"},
				{text: "San Francisco", value: "san-francisco"},
				{text: "Boston", value: "boston"},
			],
			statusOptions: [
				{text: "Plannning", value: "plannning"},
				{text: "In Progress", value: "in progress"},
				{text: "Finished", value: "finished"},
			],
			LocationOptions: [
				{text: "New York", value: "new-york"},
				{text: "Chicago", value: "chicago"},
				{text: "San Francisco", value: "san-francisco"},
				{text: "Boston", value: "boston"},
			],
			schema: null,
			newTipologyCreated: false,
			mountedCategory: false,
			typologyBody: {
				name: "",
				description: "",
				id: null,
			},
			updateCategoryMode: false,
			updateCategorySchema: {},
			disbableBottonPrev: false,
			categoryData: null,
			selectedSchema: null,
			regex: /^([a-zA-Z0-9_\s]){1,16}$/,
			nextButtonText: this.$t("Resource.Continue"),
		};
	},
	created() {
		if (!moduleCategory.isRegistered) {
			this.$store.registerModule("moduleCategory", moduleCategory);
			moduleCategory.isRegistered = true;
		}
		if (!moduleTipology.isRegistered) {
			this.$store.registerModule("moduleTipology", moduleTipology);
			moduleTipology.isRegistered = true;
		}
		this.openLoading();
		this.$store
			.dispatch("moduleTipology/fetchTypology")
			.then((res) => {
				this.closeLoading();
				if (this.$store.state.moduleCategory.categories.length > 0) {
					return this.$store.state.moduleCategory.categories;
				} else {
					return this.$store.dispatch("moduleCategory/fetchCategory");
				}
				return res;
			})
			.then((response) => {
				this.closeLoading();
				return response;
			})
			.catch((err) => {
				this.closeLoading();
				throw new Error(err);
			});
	},
	mounted() {
		this.schema = {...dafultSchema};
	},
	components: {
		FormWizard,
		TabContent,
		CategoryDefault,
		FinalizeContent,
		ResumeContent,
		NotPermission,
	},
	computed: {
		nextButtonTextComputed() {
			return (this.nextButtonText = this.$t("Resource.Continue"));
		},
		listTipologies() {
			const data = this.$store.state.moduleTipology.tipologies;
			return data.map((typology) => {
				return {label: typology.name, value: typology.id};
			});
		},
		nameP() {
			return this.typologyBody.name;
		},
		recentlyAddedCategory() {
			return this.$store.state.moduleCategory.recentlyAddedCategory;
		},
		principalProperties() {
			return this.categoryData.json_properties.filter(
				(propertie) => !propertie.additional && propertie.name !== "additional_info"
			);
		},
		additionalProperties() {
			return this.categoryData.json_properties.filter((propertie) => propertie.additional);
		},
		objectsCreatePermission() {
			return this.$store.getters.checkPermission("OBJECTS_C");
		},
	},
	methods: {
		handleChange(prevIndex, nextIndex) {
			if (prevIndex === 1 && nextIndex === 0) {
				this.mountedCategory = false;
			}
			if (prevIndex === 2 && nextIndex === 1) {
				this.categoryData = null;
				this.nextButtonText = this.$t("Resource.Continue");
			}
			if (prevIndex === 1 && nextIndex === 2) {
				this.nextButtonText = this.$t("Resource.FinishButton");
			}
			if (nextIndex === 3) {
				this.disbableBottonPrev = true;
			}
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		printHello(schemaLocal, category_local) {
			this.categoryData = schemaLocal;
			this.categoryData.name = category_local.label;
		},
		selectedSchemaEmit(value) {
			this.selectedSchema = value;
		},
		create() {
			this.$refs.CategoryDefault.createCategory();
		},
		updateCategory() {
			this.$refs.CategoryDefault.updateCategoryFromDefinition(this.typologyBody.id);
		},
		async add() {
			Object.assign(this.typologyBody, {name: this.replaceUnderscore(this.typologyBody.name)});
			try {
				const fetch = await this.$store.dispatch("moduleTipology/addTypology", {...this.typologyBody});
				const data = fetch.data;
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmTipologyCreate"),
					text: this.$t("TextConfirmTipologyCreate"),
				});
				this.typologyBody.id = data.id;
				this.newTipologyCreated = true;
				this.mountedCategory = true;
			} catch (error) {
				throw new Error(error);
			}
		},
		async updateTipology() {
			try {
				const fetch = await this.$store.dispatch("moduleTipology/updateTipology", this.typologyBody);
				const data = fetch.data;
				this.$vs.notify({
					color: "success",
					title: this.$t("TitleConfirmTipologyUpdate"),
					text: this.$t("TextConfirmTipologyUpdate"),
				});
				this.mountedCategory = true;
			} catch (error) {
				throw new Error(error);
			}
		},
		validateStep1() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-1").then((result) => {
					if (result) {
						this.newTipologyCreated ? this.updateTipology() : this.add();
						resolve(true);
					} else {
						reject(this.$t("Resource.CorrectAllValues"));
						this.$vs.notify({
							color: "danger",
							title: this.$t("Resource.NameInvalid.Title"),
							text: this.$t("Resource.NameInvalid.Text1"),
						});
					}
				});
			});
		},
		validateStep2() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-2").then((result) => {
					if (result && this.selectedSchema !== null) {
						this.$refs.CategoryDefault.getDataSchemaCategory();
						resolve(true);
					} else {
						reject(this.$t("Resource.CorrectAllValues"));
						this.$vs.notify({
							color: "danger",
							title: this.$t("Resource.SchemeInvalid.Title"),
							text: this.$t("Resource.SchemeInvalid.Text"),
						});
					}
				});
			});
		},
		validateStep3() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-3").then((result) => {
					if (result) {
						if (this.updateCategoryMode) {
							this.updateCategory();
						} else {
							this.create();
						}
						resolve(true);
					} else {
						reject(this.$t("Resource.CorrectAllValues"));
					}
				});
			});
		},
		validateStep4() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-4").then((result) => {
					if (result) {
						//this.$router.push("/apps/resource/resource-create");
						resolve(true);
					} else {
						reject(this.$t("Resource.CorrectAllValues"));
					}
				});
			});
		},
		replaceUnderscore(str) {
			var regex = new RegExp("\\s", "g");
			var replace = "_";
			var str = str;
			var str1 = str.replace(regex, replace);
			return str1;
		},
	},
};
</script>
